import { z } from 'zod';

export const walletSchema = z.looseObject({
	id: z.string(),
	companyCredits: z.number(),
	contactCredits: z.number(),
	companyMonthlyBudget: z.number(),
	contactMonthlyBudget: z.number(),
	updatedAt: z.string().nullable(),
});
